module.exports = __webpack_public_path__ + "media/images/mail-black-envelope-symbol-9c92fa0b.svg";